import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Input, Output } from '@angular/core';
import { TableauReportsService } from 'src/app/services/sm-Services/tableau-reports.service';



declare var tableau: any;
@Component({
  selector: 'app-tableaureport',
  templateUrl: './tableaureport.component.html',
  styleUrls: ['./tableaureport.component.scss']
})
export class TableaureportComponent {

  private viz: any;

  constructor(private http:HttpClient,private TableauService:TableauReportsService)
  {

  }

@Input() componentData:any;
// @Output() componentSelection:any

  ngOnInit() {
    console.log(this.componentData)
   console.log("in tableau report")
   
   this.loadreport()
  // this.loadreport(this.componentData)
  // this.openTableauReport()
  }

  // openTableauReport(): void {
  //   window.open('https://public.tableau.com/app/profile/roman.udot/viz/Turnout15_03_2024wthvariablesize/Turnout15_03_2024', '_blank');
  // }

  report_token:any
  loading:any
  token:any
  repURL:any
  loadreport() {
    this.TableauService.getToken().subscribe(
        (test: any) => {
          console.log(test)
          this.report_token=test;
          this.loading = true;
          this.TableauService.auth_token=test
          // this.token = this.TableauService.viewSiteId.auth_token;
          this.token = test
          // let headers = new HttpHeaders();
          // headers = headers.append('content-type', 'application/json')
          // headers = headers.append('X-Tableau-Auth', this.token)


          this.repURL = "https://tableau.thesmartice.com/trusted/" + this.token + "/views/" +this.componentData.Objectdata.viewurlname + "?:embed=yes&:toolbar=No&:hideToolbar=No&:hideTabs:No";
          // this.repURL = "https://tableau.thesmartice.com/trusted/" + this.token + "/views/" +this.componentData.Objectdata.viewurlname + "?:embed=yes&:toolbar=top"


              // this.repURL = "https://tableau.thesmartice.com/trusted/" + test + "/views/" + data.Objectdata.defaultviewid + "/" + data.Objectdata.viewurlname + "?:embed=No&:toolbar=No&:hideToolbar=Yes&:hideTabs:Yes";

              this.initTableau(this.repURL);

    //   this.http.get<any>("https://tableau.thesmartice.com/api/3.19/sites/" + "b3a29a33-5e47-40ef-a06c-10d443b2c478" + "/views/" + "9f8bbd7d-8658-4b1e-870e-9b87c848ecda", { headers })  
    //       .subscribe((data) => {
    // console.log(data);
    //           this.repURL = "https://tableau.thesmartice.com/trusted/" + test + "/views/" + data.Objectdata.defaultviewid + "/" + data.Objectdata.viewurlname + "?:embed=No&:toolbar=No&:hideToolbar=Yes&:hideTabs:Yes";
    //           // this.repURL=this._sanitizer.bypassSecurityTrustResourceUrl("http://tableau.thesmartice.com/trusted/" + test + "/views/" + this.TableauService.viewSiteId.contentURL + "/" + data.view.viewUrlName + "?:embed=yes&:toolbar=top" )
    //           console.log(this.repURL)
    //           // this.initTableau(this.repURL);
    
    //         }
    
    
    //         );
    
          }
      );
    }

  private initTableau(repurl:any): void {
    const containerDiv:any = document.querySelectorAll("#vizContainer");
    // const repURL = repurl;
    // this.repURL = "https://tableau.thesmartice.com/trusted/" + this.TableauService.auth_token + "/views/SLADashboard/SLADashboard" + "?:embed=No&:toolbar=No&:hideToolbar=Yes&:hideTabs:Yes";
    // console.log(this.repURL)
    // this.repURL="https://public.tableau.com/views/SuperSampleSuperstore/SuperDescriptive"
    const options = {
      hideTabs: true,
      hideToolbar: true,
      // hideTabs: false,
      // toolbar: 'top' ,
      // width: '10%',
      // height: '10%',
      onFirstInteractive: () => {
        console.log('Tableau viz is ready');
      }
    };

    const Element = document.createElement("div");
    Element.setAttribute("id",repurl);
    containerDiv[containerDiv.length-1].prepend(Element);

    this.viz = new tableau.Viz(Element, repurl, options);
  }

  
}
